import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _callSuper from "@babel/runtime/helpers/esm/callSuper";
import _inherits from "@babel/runtime/helpers/esm/inherits";
var _dec, _class, _OutcomeCheckbox;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { Checkbox } from '@instructure/ui-checkbox';
import { outcomeShape, stylesShape } from "../../store/shapes.js";
import OutcomeDescription from "../OutcomeDescription/index.js";
import OutcomeContextTag from "../OutcomeContextTag/index.js";
import { View } from '@instructure/ui-view';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
var OutcomeCheckbox = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_OutcomeCheckbox = /*#__PURE__*/function (_React$Component) {
  function OutcomeCheckbox() {
    _classCallCheck(this, OutcomeCheckbox);
    return _callSuper(this, OutcomeCheckbox, arguments);
  }
  _inherits(OutcomeCheckbox, _React$Component);
  return _createClass(OutcomeCheckbox, [{
    key: "selected",
    value: function selected() {
      return this.props.isOutcomeSelected(this.props.outcome.id);
    }
  }, {
    key: "toggleOutcomeSelection",
    value: function toggleOutcomeSelection() {
      if (this.selected()) {
        this.props.deselectOutcomeIds([this.props.outcome.id]);
      } else {
        this.props.selectOutcomeIds([this.props.outcome.id]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this,
        _outcome$source_conte;
      var outcome = this.props.outcome;
      var id = outcome.id,
        description = outcome.description,
        title = outcome.title;
      return jsx("div", {
        css: this.props.styles.checkbox,
        className: "OutcomeSelector"
      }, jsx(Checkbox, {
        id: "outcome-select-".concat(id),
        value: id,
        checked: this.selected(),
        onChange: function onChange() {
          return _this.toggleOutcomeSelection();
        },
        label: jsx("div", {
          css: this.props.styles.checkboxLabel
        }, jsx(Link, {
          onClick: function onClick(e) {
            e.preventDefault();
            _this.props.setFocusedOutcome(outcome);
          }
        }, jsx(Text, {
          size: "small"
        }, jsx("span", {
          css: this.props.styles.linkText,
          "data-automation": "outcomeCheckbox__outcomeName"
        }, jsx("span", {
          css: this.props.styles.innerLinkText
        }, title)))))
      }), outcome.friendly_description && jsx("div", {
        css: this.props.styles.checkboxFriendlyDescription
      }, jsx(View, {
        as: "div",
        margin: "x-small small 0 0",
        padding: "x-small x-small 0",
        background: "secondary",
        "data-automation": "outcomeCheckbox__friendly_description_header"
      }, jsx(Text, {
        size: "x-small",
        weight: "bold"
      }, t('Friendly Description'))), jsx(View, {
        as: "div",
        margin: "0 small 0 0",
        padding: "0 x-small x-small",
        background: "secondary",
        "data-automation": "outcomeCheckbox__friendly_description_expanded"
      }, jsx(Text, {
        size: "x-small"
      }, outcome.friendly_description))), jsx("div", {
        css: this.props.styles.checkboxDescription
      }, jsx(OutcomeDescription, {
        description: description,
        maxLines: 2
      })), jsx("div", {
        css: this.props.styles.checkboxContextTag
      }, jsx(OutcomeContextTag, {
        outcomeContextType: (_outcome$source_conte = outcome.source_context_info) === null || _outcome$source_conte === void 0 ? void 0 : _outcome$source_conte.context_type
      })));
    }
  }]);
  OutcomeCheckbox.displayName = "OutcomeCheckbox";
}(React.Component), _OutcomeCheckbox.propTypes = {
  outcome: outcomeShape.isRequired,
  setFocusedOutcome: PropTypes.func.isRequired,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  styles: stylesShape
}, _OutcomeCheckbox)) || _class);
export { OutcomeCheckbox as default };